<template>
  <v-card>
    <v-card-title class="pink">
      <h3 class="headline white--text">{{ field.name }}</h3>
    </v-card-title>
    <v-card-text>
      <h4
        class="subheading"
        v-if="
          field.range && (field.range.min !== null || field.range.max !== null)
        "
      >
        <strong>GOAL RANGE:</strong>
        {{ " " }}
        <span v-if="field.range.min === null">Up to {{ field.range.max }}</span>
        <span v-else-if="field.range.max === null"
          >At least {{ field.range.min }}</span
        >
        <span v-else>{{ field.range.min }} to {{ field.range.max }}</span>
      </h4>
      <v-form>
        <v-layout row wrap v-if="field.type === 'number'">
          <v-flex class="pl-1 xs6">
            <v-text-field
              label="Tested"
              :value="fieldState.tested"
              @input="onChangeTested"
            />
          </v-flex>
          <v-flex class="pl-1 xs6">
            <v-text-field
              label="Goal"
              v-model="fieldState.goal"
              @input="onChangeGoal"
            />
          </v-flex>
        </v-layout>
        <v-layout row wrap v-else>
          <v-flex class="pl-1 xs12">
            <v-text-field
              label="Tested"
              :value="fieldState.tested"
              @input="onChangeTested"
            />
          </v-flex>
        </v-layout>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapMutations, mapState } from "vuex";

export default {
  props: ["fieldID"],
  computed: {
    ...mapState({
      customFieldStates: "customFieldStates",
      fields: "fields",
    }),
    field() {
      const id = this.fieldID.substring(7);
      return this.fields.find((x) => x.id === id);
    },
    fieldState() {
      const existing = this.customFieldStates[this.fieldID.substring(7)] || {};
      return {
        tested:
          typeof existing.tested === "undefined"
            ? this.field.type === "number"
              ? 0
              : ""
            : existing.tested,
        goal:
          typeof existing.goal === "undefined"
            ? this.field.goal === null
              ? ""
              : this.field.goal
            : existing.goal,
      };
    },
  },
  methods: {
    ...mapMutations({
      setGoal: "customFieldStates/setGoal",
      setTested: "customFieldStates/setTested",
    }),
    onChangeTested(newValue) {
      this.setTested({
        id: this.fieldID.substring(7),
        value: this.field.type === "number" ? Number(newValue) : newValue,
      });
    },
    onChangeGoal(newValue) {
      this.setGoal({
        id: this.fieldID.substring(7),
        value: Number(newValue),
      });
    },
  },
};
</script>
